import React from 'react'
import './SubTitle.scss'

const SubTitle = ({ className = '', ...rest }) => (
  <div className={`SubTitle ${className}`}>{rest.children}</div>
)

export default SubTitle
